import './Label.css';
export var labelStyle = '_4mflwe0-2-0-1';